import { Typography } from 'antd';

import type React from 'react';

/** Inline validation message (replaces manual ant-form-item-explain markup). */
function FieldError({ children }: { children: React.ReactNode }) {
  return (
    <Typography.Text type="danger" role="alert">
      {children}
    </Typography.Text>
  );
}

export default FieldError;
